import { fromPairs } from 'lodash/fp';
import { isArray } from 'util';

export const combineSelectors = selectors => s => fromPairs(
  isArray(selectors)
  ? selectors.map(x => [x[0], x[1](s)])
  : Object.keys(selectors).map(x => [x, selectors[x](s)])
);